/** DHC uses iCat CBCT archive; Ulybka keeps legacy Vatech label. */
export function ctArchiveLabel(tenantId?: string | null): string {
  return tenantId === 'dhc' ? 'iCat' : 'Vatech'
}

export function ctArchivePcSuffix(tenantId?: string | null): string {
  const label = ctArchiveLabel(tenantId)
  return tenantId === 'dhc' ? `${label}` : `${label} ПК`
}
